import Vue from "vue";

import {
  getValutes,
  addValute,
  editValute,
  deleteValute,
  queryPaginationValutes,
  getValuteForms,
  addValuteForm,
  editValuteForm,
  deleteValuteForm,
  getValuteCategories,
  getTradePairs,
  addTradePair,
  deleteTradePair,
  editTradePair,
  getSites
} from "@/api";
//
const defaultValute = {
  _id: false,
  title: "",
  key: "",
  bestchangeKey: "",
  categories: [],
  isGet: false,
  isGive: false,
  minGive: 1,
  percentGive: 0.95,
  percentGet: 1.05,
  customPercents: [],
  course: "",
  image: false,
  isLimit: false,
  limitPercentBuy: 1,
  limitPercentSell: 1,
  step: 0,
  useWhitebitWallet: false,
  rawKey: "",
  network: null,
  depositable: true,
  withdrawable: true,
  confirmations: null,
  withFirekassa: false,
  invoiceCard: false,
  invoiceQw: false,
  invoiceYou: false,
  limitPlace: 0,
  giveWarn: "",
  getWarn: ""
};
//
export default {
  namespaced: true,

  state: {
    valutes: [],
    valutesForms: {},
    categories: [],
    tradePairs: [],
    searchString: "",
    category: null,
    active: null,
    isFiltered: false,
    valuteInModal: null,
    valuteFormsInModal: null,
    page: 1,
    limit: 10,
    sort: "title",
    dialogVisible: false,
    loading: true,
    sites: []
  },

  mutations: {
    setValutes(state, valutes) {
      state.valutes = valutes;
    },
    setSites(state, sites) {
      state.sites = sites;
    },
    setValuteForms(state, { id, forms }) {
      Vue.set(state.valutesForms, id, forms);
    },
    setCategories(state, categories) {
      state.categories = categories;
    },

    setTradePairs(state, tradePairs) {
      state.tradePairs = tradePairs;
    },
    setSearchString(state, searchString) {
      state.searchString = searchString;
    },
    setCategory(state, category) {
      state.category = category;
    },
    setActive(state, active) {
      state.active = active;
    },
    setValuteInModal(state, valuteInModal) {
      state.valuteInModal = valuteInModal;
    },
    setValuteFormsInModal(state, valuteFormsInModal) {
      state.valuteFormsInModal = valuteFormsInModal;
    },
    setIsFiltered(state, isFiltered) {
      state.isFiltered = isFiltered;
    },
    setPage(state, page) {
      state.page = page;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setDialogVisible(state, dialogVisible) {
      state.dialogVisible = dialogVisible;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async filterQueryBuilder(store) {
      if (
        !store.state.searchString &&
        !store.state.category &&
        !store.state.active
      ) {
        store.commit("setIsFiltered", false);
        return {};
      }

      const queryBuilders = [
        {
          state: "searchString",
          builder: () => {
            return {
              $or: [
                {
                  title: {
                    $regex: `.*${store.state["searchString"]}.*`,
                    $options: "i"
                  }
                },
                {
                  key: {
                    $regex: `.*${store.state["searchString"]}.*`,
                    $options: "i"
                  }
                }
              ]
            };
          }
        },
        {
          state: "category",
          builder: () => {
            return {
              categories: store.state.category
            };
          }
        },
        {
          state: "active",
          builder: () => {
            if (store.state.active === "true") {
              return {
                $or: [
                  {
                    $and: [
                      {
                        depositable: true
                      },
                      {
                        isGet: true
                      }
                    ]
                  },
                  {
                    $and: [
                      {
                        withdrawable: true
                      },
                      {
                        isGive: true
                      }
                    ]
                  }
                ]
              };
            } else {
              return {
                $and: [
                  {
                    $or: [
                      {
                        depositable: false
                      },
                      {
                        isGet: false
                      }
                    ]
                  },
                  {
                    $or: [
                      {
                        withdrawable: false
                      },
                      {
                        isGive: false
                      }
                    ]
                  }
                ]
              };
            }
          }
        }
      ];

      const query = {
        $and: queryBuilders
          .filter(b => !!store.state[b.state])
          .map(b => b.builder())
      };

      store.commit("setIsFiltered", true);

      return query;
    },
    async queryPaginationValutes(store) {
      store.commit("setLoading", true);
      const response = await queryPaginationValutes({
        page: store.state.page,
        limit: store.state.limit,
        sort: store.state.sort,
        query: await store.dispatch("filterQueryBuilder")
      });
      //
      const valutes = response.data.result;
      //
      valutes.docs.map(valute => {
        store.dispatch("getValuteForms", valute._id);
      });
      //
      store.commit("setValutes", valutes);
      //
      store.commit("setLoading", false);
      return response;
    },
    async getSites(store) {
      store.commit("setLoading", true);
      const response = await getSites({
        pagination: false
      });
      //
      const sites =
        (response.data && response.data.result && response.data.result.docs) ||
        [];
      const filteredSites = Array.from(new Set(sites.map(site => site.name)));
      store.commit("setSites", filteredSites);
      //
      store.commit("setLoading", false);
      return response;
    },
    getValutes(store) {
      return getValutes().then(response => {
        const valutes = response.data.result;
        //
        valutes.map(valute => {
          store.dispatch("getValuteForms", valute._id);
        });
        //
        store.commit("setValutes", valutes);
        //
        return response;
      });
    },
    getSortedValutes(store) {
      return getValutes().then(response => {
        const valutes = response.data.result.sort((a, b) => {
          if (
            a.categories &&
            a.categories[0] &&
            a.categories[0].name === "Банки"
          ) {
            return -1;
          } else {
            return 1;
          }
        });
        valutes.map(valute => {
          store.dispatch("getValuteForms", valute._id);
        });
        //
        store.commit("setValutes", valutes);
        //
        return response;
      });
    },
    getSortedValutesWithoutForms(store) {
      return getValutes().then(response => {
        const valutes = response.data.result.sort((a, b) => {
          if (
            a.categories &&
            a.categories[0] &&
            a.categories[0].name === "Банки"
          ) {
            return -1;
          } else {
            return 1;
          }
        });
        //
        store.commit("setValutes", valutes);
        //
        return response;
      });
    },

    addValute(store, valute) {
      return addValute(valute).then(async response => {
        await store.dispatch("queryPaginationValutes");
        //
        return response;
      });
    },

    editValute(store, { id, valute }) {
      return editValute(id, valute).then(async response => {
        await store.dispatch("queryPaginationValutes");
        //
        return response;
      });
    },

    deleteValute(store, id) {
      return deleteValute(id).then(async response => {
        await store.dispatch("queryPaginationValutes");
        //
        return response;
      });
    },

    getValuteForms(store, id) {
      return getValuteForms(id).then(response => {
        store.commit("setValuteForms", { id, forms: response.data.result });
        //
        return response;
      });
    },

    addValuteForm(store, { valuteId, formData }) {
      return addValuteForm(valuteId, formData);
    },

    editValuteForm(store, { valuteId, formId, formData }) {
      return editValuteForm(valuteId, formId, formData);
    },

    deleteValuteForm(store, { valuteId, formId }) {
      return deleteValuteForm(valuteId, formId);
    },

    getValuteCategories(store) {
      return getValuteCategories().then(response => {
        store.commit("setCategories", response.data.result);
        return response;
      });
    },
    getTradePairs(store) {
      return getTradePairs().then(response => {
        const tradePairs = response.data;
        //
        store.commit("setTradePairs", tradePairs);
        //
        return response;
      });
    },

    addTradePair(store, tradePair) {
      return addTradePair(tradePair).then(response => {
        store.dispatch("getTradePairs");
        //
        return response;
      });
    },
    deleteTradePair(store, id) {
      return deleteTradePair(id).then(response => {
        store.dispatch("getValutes");
        //
        return response;
      });
    },
    editTradePair(store, data) {
      return editTradePair(data).then(response => {
        store.dispatch("getValutes");
      });
    },
    changeSearchString(store, payload) {
      if (payload.searchString !== undefined) {
        store.commit("setSearchString", payload.searchString);
      }
    },
    performSearch(store, payload) {
      if (store.state.searchString !== "") {
        store.commit("setCategory", null);
        store.commit("setActive", null);
        store.commit("setPage", 1);
      }

      store.dispatch("queryPaginationValutes");
    },
    changeCategory(store, payload) {
      if (payload.category !== undefined) {
        store.commit("setCategory", payload.category);
        store.commit("setPage", 1);
        store.dispatch("queryPaginationValutes");
      }
    },
    changeActive(store, payload) {
      if (payload.active !== undefined) {
        store.commit("setActive", payload.active);
        store.commit("setPage", 1);
        store.dispatch("queryPaginationValutes");
      }
    },
    changeLoading(store, payload) {
      if (payload.loading !== undefined) {
        store.commit("setLoading", payload.loading);
      }
    },
    changeDataInModal(store, payload) {
      if (payload.valuteInModal !== undefined) {
        let valute = payload.valuteInModal;
        valute.rawKey = valute.rawKey || valute.key;
        store.commit("setValuteInModal", valute);
        store.commit(
          "setValuteFormsInModal",
          store.state.valutesForms[valute._id]
        );
      } else {
        store.commit("setValuteInModal", { ...defaultValute });
        store.commit("setValuteFormsInModal", {});
      }
    },
    changeDialogVisible(store, payload) {
      if (payload.dialogVisible !== undefined) {
        store.commit("setDialogVisible", payload.dialogVisible);
      }
    },
    async resetSearch(store, payload) {
      store.commit("setSearchString", "");
      store.commit("setCategory", null);
      store.commit("setActive", null);
      await store.dispatch("queryPaginationValutes");
    },
    async changeLimit(store, payload) {
      if (payload.limit !== undefined) {
        store.commit("setLimit", payload.limit);
        await store.dispatch("queryPaginationValutes");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("queryPaginationValutes");
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.valutes.totalPages &&
        store.state.valutes.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("queryPaginationValutes");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/valutes.js